// extracted by mini-css-extract-plugin
export default {"root":"_0YrQGuoAGEHNogcMdIU","inline":"k0d9Coi_VOmPDV1PHEUX"};